var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 182,
    height: 37.241,
    viewBox: "0 0 182 37.241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1916",
    "data-name": "Rechteck 1916",
    width: 182,
    height: 37.241,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6730",
    "data-name": "Gruppe 6730",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6118",
    "data-name": "Pfad 6118",
    d: "M52.081,149.461a2.218,2.218,0,0,0,2.213-.281,29.3,29.3,0,0,0,4-3.849l.878.591-1.9,2.152,4.718,4.8a1.692,1.692,0,0,1,.329.471,1.713,1.713,0,0,1,.156.872,8.838,8.838,0,0,0,2.414-5.212,5.809,5.809,0,0,0-1.738-4.129,6.587,6.587,0,0,0-4.18-1.725,4.822,4.822,0,0,0-3.892.971l-.146.115-2.7,2.72c-1.57,1.662-.611,2.562.381,2.623",
    transform: "translate(-36.94 -131.539)",
    fill: "#cf2525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6119",
    "data-name": "Pfad 6119",
    d: "M46.423,149a6.308,6.308,0,0,0,1.924,4.462c.74.737,1.592,1.59,2.464,2.461l5.028,4.986a1.153,1.153,0,0,0,.822.336A1.271,1.271,0,0,0,57.923,160a1.15,1.15,0,0,0-.334-.843l-4.539-4.587,1.009-.925,4.539,4.588a1.166,1.166,0,0,0,.822.335,1.278,1.278,0,0,0,1.265-1.264,1.157,1.157,0,0,0-.335-.822L55.81,151.9l.92-.942,4.678,4.547a1.2,1.2,0,0,0,1.679-.014c.235-.235.365-.348.374-.674a1.154,1.154,0,0,0-.335-.843l-4.667-5.089-.143.146a6.753,6.753,0,0,1-2.246,1.549c-1.759.713-5.563-1.049-2.727-4.192l2.312-2.313c-2.593-2.016-6.373-.311-7.494.8A5.805,5.805,0,0,0,46.423,149",
    transform: "translate(-39.089 -131.531)",
    fill: "#cf2525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6120",
    "data-name": "Pfad 6120",
    d: "M58.941,167.653a13.563,13.563,0,0,1-8.609-3.068L45.9,165.64l1.658-4.131a13.613,13.613,0,1,1,11.381,6.144m0-31.255a17.638,17.638,0,0,0-14.778,27.271l-1.775,5.121,5.405-1.079A17.64,17.64,0,1,0,58.941,136.4",
    transform: "translate(-41.3 -134.438)",
    fill: "#cf2525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6121",
    "data-name": "Pfad 6121",
    d: "M85.235,154.392c-4.975-.1-10.622.776-10.622,5.647a4.036,4.036,0,0,0,4.3,4.352,6.24,6.24,0,0,0,6.061-4.2,4.745,4.745,0,0,0,.259-1.45Zm.673,12.8-.362-3.161H85.39a9.336,9.336,0,0,1-7.667,3.731c-5.078,0-7.667-3.575-7.667-7.2,0-6.061,5.387-9.377,15.077-9.325v-.518c0-2.073-.571-5.8-5.7-5.8a12.5,12.5,0,0,0-6.528,1.864l-1.036-3a15.565,15.565,0,0,1,8.238-2.227c7.667,0,9.533,5.232,9.533,10.258v9.378a35.17,35.17,0,0,0,.415,6.01Z",
    transform: "translate(-28.891 -132.218)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6122",
    "data-name": "Pfad 6122",
    d: "M88.783,162.526a11.953,11.953,0,0,0,6.01,1.814c3.315,0,4.87-1.658,4.87-3.731,0-2.176-1.3-3.367-4.663-4.611-4.508-1.606-6.632-4.093-6.632-7.1,0-4.041,3.264-7.358,8.652-7.358a12.515,12.515,0,0,1,6.166,1.555l-1.139,3.315a9.759,9.759,0,0,0-5.129-1.45c-2.694,0-4.2,1.555-4.2,3.42,0,2.071,1.5,3,4.767,4.249,4.352,1.658,6.581,3.834,6.581,7.563,0,4.4-3.42,7.513-9.378,7.513A14.3,14.3,0,0,1,87.644,166Z",
    transform: "translate(-21.301 -132.218)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6123",
    "data-name": "Pfad 6123",
    d: "M103.116,162.526a11.953,11.953,0,0,0,6.01,1.814c3.315,0,4.87-1.658,4.87-3.731,0-2.176-1.3-3.367-4.663-4.611-4.508-1.606-6.632-4.093-6.632-7.1,0-4.041,3.264-7.358,8.652-7.358a12.515,12.515,0,0,1,6.166,1.555l-1.139,3.315a9.764,9.764,0,0,0-5.129-1.45c-2.694,0-4.2,1.555-4.2,3.42,0,2.071,1.5,3,4.767,4.249,4.352,1.658,6.581,3.834,6.581,7.563,0,4.4-3.42,7.513-9.378,7.513A14.3,14.3,0,0,1,101.977,166Z",
    transform: "translate(-15.116 -132.218)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6124",
    "data-name": "Pfad 6124",
    d: "M117.711,144.924h4.559V170h-4.559Zm5.078-7.046a2.824,2.824,0,0,1-5.647,0,2.778,2.778,0,0,1,2.85-2.85,2.707,2.707,0,0,1,2.8,2.85",
    transform: "translate(-8.572 -135.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6125",
    "data-name": "Pfad 6125",
    d: "M125.917,162.526a11.953,11.953,0,0,0,6.01,1.814c3.315,0,4.87-1.658,4.87-3.731,0-2.176-1.3-3.367-4.663-4.611-4.508-1.606-6.632-4.093-6.632-7.1,0-4.041,3.264-7.358,8.652-7.358a12.515,12.515,0,0,1,6.166,1.555l-1.139,3.315a9.764,9.764,0,0,0-5.129-1.45c-2.694,0-4.2,1.555-4.2,3.42,0,2.071,1.5,3,4.767,4.249,4.352,1.658,6.581,3.834,6.581,7.563,0,4.4-3.42,7.513-9.378,7.513A14.292,14.292,0,0,1,124.778,166Z",
    transform: "translate(-5.276 -132.218)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6126",
    "data-name": "Pfad 6126",
    d: "M146.692,136.911v7.2h6.528v3.47h-6.528v13.522c0,3.109.88,4.87,3.42,4.87a10.109,10.109,0,0,0,2.641-.311l.208,3.42a11.169,11.169,0,0,1-4.041.621A6.315,6.315,0,0,1,144,167.789c-1.3-1.347-1.762-3.575-1.762-6.528V147.583H138.35v-3.47h3.885V138.1Z",
    transform: "translate(0.581 -134.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6127",
    "data-name": "Pfad 6127",
    d: "M163.3,163.493c-4.429,0-8.019-3.99-8.019-8.91s3.59-8.911,8.019-8.911,8.021,3.99,8.021,8.911-3.592,8.91-8.021,8.91m0-21.852a12.942,12.942,0,1,0,12.943,12.943A12.943,12.943,0,0,0,163.3,141.641",
    transform: "translate(5.761 -132.175)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.193b3e5e.svg";
export { ForwardRef as ReactComponent };